module.exports = __webpack_public_path__ + "static/media/triobanner.52865e76.png";